/**
 * Initializes one home hero carousel.
 * @param {HTMLElement} section
 */
function initializeHomeHero(section) {
  if (section.dataset.initialized === 'true') return;

  const swiperElement = section.querySelector('[data-home-hero-swiper]');
  if (!(swiperElement instanceof HTMLElement) || typeof window.Swiper !== 'function') return;

  section.dataset.initialized = 'true';
  const autoplayEnabled = section.dataset.autoplay === 'true';
  const autoplayDelay = Number.parseInt(section.dataset.autoplayDelay || '7000', 10);
  const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

  const autoplay = autoplayEnabled && slideCount > 1
    ? {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }
    : false;

  section.homeHeroSwiper = new window.Swiper(swiperElement, {
    slidesPerView: 1,
    loop: slideCount > 1,
    speed: 600,
    autoplay,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
    },
    navigation: {
      nextEl: section.querySelector('[data-home-hero-next]'),
      prevEl: section.querySelector('[data-home-hero-prev]'),
    },
    observer: true,
    observeParents: true,
  });
}

function initializeHomeHeroes(scope = document) {
  scope.querySelectorAll('[data-home-hero]').forEach((section) => {
    if (section instanceof HTMLElement) initializeHomeHero(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeHomeHeroes(), { once: true });
} else {
  initializeHomeHeroes();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeHomeHeroes(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target instanceof Element ? event.target.querySelector('[data-home-hero]') : null;
  section?.homeHeroSwiper?.destroy(true, true);
});
